var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg02Kikou(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;fill:none;}\n\t.st1{fill:#F36415;}\n\t.st2{display:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.3,28h9.8c0.6,0,1.2-0.2,1.7-0.5c1.3-0.7,2.1-2.1,2.1-3.7c0-2.3-1.8-4.2-4-4.2c-0.6,0-1.1,0.1-1.6,0.4 c-0.2-1.1-0.7-2-1.4-2.7C20.1,16.5,19,16,17.8,16c-1.3,0-2.4,0.5-3.3,1.4c-0.7,0.7-1.2,1.7-1.3,2.8c-0.4-0.2-0.9-0.3-1.4-0.3 c-2.1,0-3.8,1.8-3.8,4s1.7,4,3.8,4h2.5L14.3,28z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9,2c0.3,0,0.7,0,1,0.1V0H8v2.1C8.3,2,8.7,2,9,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.8,3.4L3.3,1.9L1.9,3.3l1.5,1.5C3.8,4.3,4.3,3.8,4.8,3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2,9c0-0.3,0-0.7,0.1-1H0v2h2.1C2,9.7,2,9.3,2,9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.6,4.8l1.5-1.5l-1.4-1.4l-1.5,1.5C13.7,3.8,14.2,4.3,14.6,4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.2,14.6l1.5,1.5l1.4-1.4l-1.5-1.5C14.2,13.7,13.7,14.2,13.2,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.4,13.2l-1.5,1.5l1.4,1.4l1.5-1.5C4.3,14.2,3.8,13.7,3.4,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.9,8C16,8.3,16,8.7,16,9s0,0.7-0.1,1H18V8H15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9,16c-0.3,0-0.7,0-1-0.1V18h2v-2.1C9.7,16,9.3,16,9,16z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 9,
    cy: 9,
    rx: 5,
    ry: 5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_px\\u5358\\u4F4D",
    className: "st2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02Kikou);
export default __webpack_public_path__ + "static/media/02_kikou.c9947d304b8fcc2455965625b534da63.svg";
export { ForwardRef as ReactComponent };